(function($){ 
  // THESE ARE INITIALISATIONS AND OPTIONS FOR THE PRODUCT TEMPLATE GALLERY ONLY
  theme.Product();

  /* SLICK SLIDER SWITH BASED ON VARIANTS */
  $('.product-single__thumbnails .product-single__photos--thumbnail').each(function(index){
    var thisID = $(this).data('id');

    slickIndex.push(thisID);
  });


    
    // $('.MagicToolboxSelectorsContainer').slick({
    //   slidesToShow: 4,
    //   slidesToScroll: 1,
    //   arrows: true,
    //   fade: false,
    //   vertical: true,
    //   infinite: false,
    //   nextArrow:'<svg class="feature_arrow_next2" width="10" height="18" viewBox="0 0 10 18" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><g stroke-width="2" stroke="#111" stroke-linecap="round" stroke-linejoin="round"><path d="M1 1l8 8M9 9l-8 8"/></g></g></svg></a></li>',
    //   prevArrow:'<svg class="feature_arrow_prev2" width="10" height="18" viewBox="0 0 10 18" xmlns="http://www.w3.org/2000/svg"><g stroke-width="2" stroke="#111" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path d="M9 1L1 9M1 9l8 8"/></g></svg></a></li>',
    //   responsive: [
    //     {
    //       breakpoint: 1200,
    //       settings: {
    //         slidesToShow: 2,
    //         slidesToScroll: 1,
    //         dots: false,
    //         centerMode: true,
    //         centerPadding: '40px',
    //         vertical: false,
    //         arrows: false,
    //         draggable: true,
    //         swipeToSlide: true,
    //         infinite: true
    //       },
    //     },
    //     {
    //       breakpoint: 500,
    //         settings: {
    //           slidesToShow: 2,
    //           slidesToScroll: 1,
    //           dots: false,
    //           centerMode: true,
    //           centerPadding: '40px',
    //           vertical: false,
    //           arrows: false,
    //           draggable: true,
    //           swipeToSlide: true,
    //           infinite: true
    //         },
    //       },
    //         {
        
    //           breakpoint: 350,
    //           settings: {
    //             slidesToShow: 2,
    //             slidesToScroll: 1,
    //             dots: false,
    //             centerMode: true,
    //             centerPadding: '40px',
    //             vertical: false,
    //             arrows: false,
    //             draggable: true,
    //             swipeToSlide: true,
    //             infinite: true
    //           }

    //       }]
    // });


  // THIS IS A HELPER FOR OPTIONS SELECTION
  $('.single-option-selector').each(function(){
    $(this).on('change', function(e){
      // This will trigger every time someone changes a select box
      // Selected variant is set to data-variant, this is controlled in theme.js.liquid
      // Helpers
      var selectorID    = $(this).prop('id')
      ,   selectorClass = $(this).prop('class')
      ,   selectorData  = $(this).data('index')
      ,   selectorVal   = $(this).val();

    });
  });
})(jQuery);